import { Routes } from '@angular/router';
import { AppLayout } from '@/app/layout/components/app.layout';
import { Landing } from '@/app/pages/landing/landing';
import { Notfound } from '@/app/pages/notfound/notfound';
import { authGuard, permisoGuard } from '@/app/core/auth/auth.guard';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('./app/pages/dashboards/reportesdashboard').then((c) => c.ReportesDashboard),
                data: { breadcrumb: 'Inicio' }
            },
            {
                path: 'dashboard-banking',
                loadComponent: () => import('./app/pages/dashboards/bankingdashboard').then((c) => c.BankingDashboard),
                data: { breadcrumb: 'Banking Dashboard' }
            },
            {
                path: 'actualizar-reportes',
                canActivate: [permisoGuard],
                loadComponent: () => import('./app/pages/reportes/actualizar-masivo/actualizar-main.page').then((c) => c.ActualizarMain),
                data: { breadcrumb: 'Actualizar Datos', permiso: 'reportes.crear' }
            },
            {
                path: 'notificaciones',
                loadComponent: () => import('./app/pages/notificaciones/notificaciones.page').then((c) => c.NotificacionesPage),
                data: { breadcrumb: 'Notificaciones' }
            },
            {
                path: 'reportes',
                canActivate: [permisoGuard],
                loadComponent: () => import('./app/pages/reportes/menu-reportes/menu-reportes-main.page').then((c) => c.MenuReportesMain),
                data: { breadcrumb: 'Reportes', permiso: 'reportes.crear' }
            },
            {
                path: 'armar-reporte',
                canActivate: [permisoGuard],
                loadComponent: () => import('./app/pages/armarReporte/armar-reporte-main.page').then((c) => c.ArmarReporte),
                data: { breadcrumb: 'Armar reporte', permiso: 'reportes.crear' }
            },
            {
                path: 'uikit',
                data: { breadcrumb: 'UI Kit' },
                loadChildren: () => import('@/app/pages/uikit/uikit.routes')
            },
            {
                path: 'documentation',
                data: { breadcrumb: 'Documentation' },
                loadComponent: () => import('./app/pages/documentation/documentation').then((c) => c.Documentation)
            },
            {
                path: 'pages',
                loadChildren: () => import('@/app/pages/pages.routes')
            },
            {
                path: 'apps',
                loadChildren: () => import('@/app/apps/apps.routes'),
                data: { breadcrumb: 'Apps' }
            },

            {
                path: 'blocks',
                data: { breadcrumb: 'Free Blocks' },
                loadChildren: () => import('./app/pages/blocks/blocks.routes')
            },
            {
                path: 'ecommerce',
                loadChildren: () => import('@/app/pages/ecommerce/ecommerce.routes'),
                data: { breadcrumb: 'E-Commerce' }
            },
            {
                path: 'profile',
                loadChildren: () => import('@/app/pages/usermanagement/usermanagement.routes')
            },
            {
                path: 'administracion/usuarios',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Usuarios', permiso: 'usuarios.ver' },
                loadComponent: () => import('@/app/pages/administracion/usuarios.page').then((c) => c.UsuariosPage)
            },
            {
                path: 'administracion/roles',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Roles', permiso: 'roles.ver' },
                loadComponent: () => import('@/app/pages/administracion/roles.page').then((c) => c.RolesPage)
            },
            {
                path: 'administracion/tenant',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Mi empresa', permiso: 'tenant.ver' },
                loadComponent: () => import('@/app/pages/administracion/tenant.page').then((c) => c.TenantPage)
            },
            {
                path: 'administracion/configuracion',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Configuración', permiso: 'tenant.ver' },
                loadComponent: () => import('@/app/pages/administracion/configuracion-tenant.page').then((c) => c.ConfiguracionTenantPage)
            },
            {
                path: 'administracion/grupos',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Grupos', permiso: 'grupos.ver' },
                loadComponent: () => import('@/app/pages/administracion/grupos.page').then((c) => c.GruposPage)
            },
            {
                path: 'administracion/auditoria',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Historial de accesos', permiso: 'auditoria.ver' },
                loadComponent: () => import('@/app/pages/administracion/auditoria.page').then((c) => c.AuditoriaPage)
            },
            {
                path: 'clientes',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Clientes', permisos: ['clientes.ver', 'clientes.asignarusuarios', 'clientes.asignargrupos'] },
                loadComponent: () => import('@/app/pages/clientes/clientes.page').then((c) => c.ClientesPage)
            },
            {
                path: 'resumen-reportes',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Resumen de reportes', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/resumen-reportes/resumen-reportes.page').then((c) => c.ResumenReportesPage)
            },
            {
                path: 'reporte/sii',
                redirectTo: 'reporte/sii/datos-tributarios',
                pathMatch: 'full'
            },
            {
                path: 'sii-reportes',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'SII Reportes', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/sii-reportes/reportes-main.page').then((c) => c.ReportesMainPage)
            },
            {
                path: 'previred-reportes',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Previred', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/previred-reportes/reportes-main.page').then((c) => c.PreviredReportesMainPage)
            },
            {
                path: 'direccion-trabajo-reportes',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Dirección del Trabajo', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/direccion-trabajo-reportes/reportes-main.page').then((c) => c.DireccionTrabajoReportesMainPage)
            },
            {
                path: 'tgr-reportes',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'TGR', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/tgr-reportes/reportes-main.page').then((c) => c.TgrReportesMainPage)
            },
            {
                path: 'reporte/sii/datos-tributarios',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Datos Tributarios', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/datos-tributarios.page').then((c) => c.DatosTributariosPage)
            },
            {
                path: 'reporte/sii/boletas-honorarios',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Boletas Honorarios', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/boletas-honorarios.page').then((c) => c.BoletasHonorariosPage)
            },
            {
                path: 'reporte/sii/registro-compras-ventas',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Registro de Compras y Ventas', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/registro-compras-ventas.page').then((c) => c.RegistroComprasVentasPage)
            },
            {
                path: 'reporte/sii/comunicaciones',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Comunicaciones del SII', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/comunicaciones.page').then((c) => c.ComunicacionesPage)
            },
            {
                path: 'reporte/sii/reporte-f29',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Reporte F29', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/reporte-f29.page').then((c) => c.ReporteF29Page)
            },
            {
                path: 'reporte/sii/reporte-f50',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Reporte F50', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/reporte-f50.page').then((c) => c.ReporteF50Page)
            },
            {
                path: 'reporte/sii/reporte-f22',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Reporte F22', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/reporte-f22.page').then((c) => c.ReporteF22Page)
            },
            {
                path: 'reporte/sii/declaraciones-juradas',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Declaraciones Juradas', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/declaraciones-juradas.page').then((c) => c.ReporteDeclaracionesJuradasPage)
            },
            {
                path: 'reporte/sii/multas',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Multas', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/multas.page').then((c) => c.MultasPage)
            },
            {
                path: 'reporte/sii/propiedades',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Propiedades', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/propiedades.page').then((c) => c.PropiedadesPage)
            },
            {
                path: 'reporte/sii/deudas-propiedades',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Deudas de Propiedades', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/deudas-propiedades.page').then((c) => c.DeudasPropiedadesPage)
            },
            {
                path: 'reporte/sii/devoluciones-iva',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Devoluciones IVA', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/devoluciones-iva.page').then((c) => c.DevolucionesIvaPage)
            },
            {
                path: 'reporte/sii/peticiones-administrativas',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Peticiones Administrativas', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/peticiones-administrativas.page').then((c) => c.PeticionesAdministrativasPage)
            },
            {
                path: 'reporte/sii/iva-postergado',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'IVA Postergado', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/iva-postergado.page').then((c) => c.IvaPostergadoPage)
            },
            {
                path: 'reporte/sii/f29-observado',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'F29 Observado', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/f29-observado.page').then((c) => c.F29ObservadoPage)
            },
            {
                path: 'reporte/sii/correo-inscrito',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Correo Inscrito', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/correo-inscrito.page').then((c) => c.CorreoInscritoPage)
            },
            {
                path: 'reporte/sii/agentes-retenedores',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Agentes Retenedores', permiso: 'reportes.ver' },
                loadComponent: () => import('@/app/pages/reportes/agentes-retenedores.page').then((c) => c.AgentesRetenedoresPage)
            },
            {
                path: 'plataforma/tenants',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Tenants', plataforma: true },
                loadComponent: () => import('@/app/pages/administracion/plataforma-tenants.page').then((c) => c.PlataformaTenantsPage)
            },
            {
                path: 'plataforma/catalogos-configuracion',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Catálogos de configuración', plataforma: true },
                loadComponent: () => import('@/app/pages/administracion/catalogos-configuracion.page').then((c) => c.CatalogosConfiguracionPage)
            },
            {
                path: 'plataforma/planes',
                canActivate: [permisoGuard],
                data: { breadcrumb: 'Planes', plataforma: true },
                loadComponent: () => import('@/app/pages/administracion/plataforma-planes.page').then((c) => c.PlataformaPlanesPage)
            }
        ]
    },
    { path: 'landing', component: Landing },
    { path: 'notfound', component: Notfound },
    {
        path: 'sin-acceso',
        canActivate: [authGuard],
        loadComponent: () => import('@/app/pages/auth/sin-acceso').then((c) => c.SinAccesoPage)
    },
    {
        path: 'auth',
        loadChildren: () => import('@/app/pages/auth/auth.routes')
    },
    { path: '**', redirectTo: '/notfound' }
];
